// extracted by mini-css-extract-plugin
export default {"wrap":"bindMobile-module--wrap--ZvUC4","title":"bindMobile-module--title--7e3jn","subTitle":"bindMobile-module--subTitle--ZwbMP","noTip":"bindMobile-module--noTip--Wvfqh"};